"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchLogoSaga = fetchLogoSaga;
exports.processLogosCompetitorsSaga = processLogosCompetitorsSaga;
exports.logosProviderSaga = logosProviderSaga;
const effects_1 = require("redux-saga/effects");
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const index_1 = require("../../api/index");
const errors_1 = require("../../utils/errors");
const slice_1 = require("./slice");
function* fetchLogoSaga(action) {
    const logosApi = index_1.ApiManager.getApi(betweb_openapi_axios_1.LogosApi);
    const { ids, entityType } = action.payload;
    try {
        const { data: resData } = yield (0, effects_1.call)(() => logosApi.getLogos({ entityType, ids }));
        yield (0, effects_1.put)(slice_1.logosProviderActions.fetchLogoSuccess({ resData }));
        return resData.data;
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error fetching logos', e);
        const errorPayload = {
            ...error,
            entityType,
        };
        yield (0, effects_1.put)(slice_1.logosProviderActions.fetchLogoError(errorPayload));
        return null;
    }
}
function* processLogosCompetitorsSaga({ events }) {
    const competitorIds = events.flatMap((event) => event.competitors.map((competitor) => competitor.id));
    const uniqueIds = [...new Set(competitorIds)];
    const entityType = betweb_openapi_axios_1.LogoEntityType.Competitor;
    yield (0, effects_1.put)(slice_1.logosProviderActions.fetchLogo({ ids: uniqueIds, entityType }));
}
function* logosProviderSaga() {
    yield (0, effects_1.all)([(0, effects_1.takeEvery)(slice_1.logosProviderActions.fetchLogo.type, fetchLogoSaga)]);
}
//# sourceMappingURL=saga.js.map